// https://publisher.dev.kxsz.net/api/pay/basic/send-verify-code

//192.168.1.148:8302/api/publishing-house/order/import

import axios from "axios";
/**
 * 获取验证码
 */
export const verifyCode = async <T>(params: {
  mobile: string;
  captcha_dots?: Array<{ x: number; y: number }>;
  captcha_key: string;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/basic/send-verify-code",
    params
  );
  return result.data;
};

/**
 * 获取人机验证码
 */
export const getVerifyCaptcha = async <T>() => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/basic/get-verify-captcha"
  );
  return result.data;
};

/**
 *
 * @param params 登陆
 * @returns
 */
export const login = async <T>(params: {
  mobile: string;
  verify_code: string;
}) => {
  const result = await axios.post<ResponseJson<T>>(
    "/api/pay/basic/login",
    params
  );
  return result.data;
};
